import React from "react"
import { Link } from "react-router-dom"

export default function Error() {
  return (
    <>
      <section className="max-width">
        <div className="flex flex-col items-center justify-center text-center h-screen">
          <h1 className="text-base">
            Error 404{" "}
            <span className="text-sm text-slate-700 font-light">
              | The page you were looking for was not found
            </span>
          </h1>
          <Link to="/" className="btn-black mt-5">
            &larr; Back to Homepage
          </Link>
        </div>
      </section>
    </>
  )
}
